// extracted by mini-css-extract-plugin
module.exports = {"title":"policy_title__37Ous","section":"policy_section__2xL4V","header":"policy_header__Fkp7S","context":"policy_context__EsvuZ"};